import React from 'react';
import PromiseCard from './promise-card';
import { PromiseCardsSectionProps } from '../types';

const PromiseCardsSection: React.FC<PromiseCardsSectionProps> = ({
  promiseCards,
}) => {
  return (
    <div className="w-full flex flex-wrap mt-12 sm:mt-8">
      {promiseCards.map((card) => (
        <PromiseCard key={card.id} card={card} />
      ))}
    </div>
  );
};

export default PromiseCardsSection;
